<template>
  <div style="margin: 100px auto 100px; max-width: 650px; text-align: left;">
    <form name="Shisan">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="250px" class="demo-ruleForm">
        <el-form-item :label="$t('JDSLoan.moneyAmount')" prop="name">
          <input type="number" id="P1" class="input" name="moneyAmount" value="100" />&nbsp;
          <font class="font">{{$t("JDSLoan.ten_thousand")}}</font>
        </el-form-item>

        <el-form-item :label="$t('JDSLoan.loanAmount')" prop="name">
          <input type="number" id="P2" class="input" name="loanAmount" value="50" />&nbsp;
          <font class="font">{{$t("JDSLoan.ten_thousand")}}</font>
        </el-form-item>

        <el-form-item :label="$t('JDSLoan.desiredPeriod')">
          <input type="text" id="P3" class="input" name="desiredYear" style="width: 70px;" value="1">
          {{$t("JDSLoan.year")}}

          <input type="text" id="P5" class="input" name="desiredMonth" style="width: 70px;" value="1">
          {{$t("JDSLoan.month")}}
        </el-form-item>

        <el-form-item :label="$t('JDSLoan.interest_rate')">
          <input type="text" id="P4" class="input" name="interestRate" style="width: 70px;" value="10"> %
        </el-form-item>

        <hr>

        <el-form-item>
          <el-button type="primary" @click="Main()">{{$t("JDSLoan.calculate")}}</el-button>
          <el-button type="primary" v-on:click="clearAll">{{$t("JDSLoan.clear")}}</el-button>
        </el-form-item>

        <hr>

        <el-form-item :label="$t('JDSLoan.S1')" prop="name">
          <input class="input" id="S1" name="S1" /> {{$t("JDSLoan.yen")}}
        </el-form-item>

        <el-form-item :label="$t('JDSLoan.S2')" prop="name">
          <input class="input" id="S2" name="S2" /> {{$t("JDSLoan.yen")}}
        </el-form-item>

      </el-form>
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // ruleForm: {
        //   moneyAmount: "",
        //   loanAmount: "",
        //   desiredYear: "",
        //   desiredMonth: "",
        //   interestRate: "",
        //   monthlyReayment: "",
        //   bonusMonthlyReayment: ""
        // },
        ruleForm: {
          P1: "",
          P2: "",
          P3: "",
          P4: "",
          P5: "",
          S1: "",
          S2: ""
        },
        rules: {
          P1: [{
            required: true,
            rigger: "blur"
          }],
          P2: [{
            required: true,
            rigger: "blur"
          }],
          P3: [{
            required: true,
            rigger: "blur"
          }],
          P4: [{
            required: true,
            rigger: "blur"
          }],
          P5: [{
            required: true,
            rigger: "blur"
          }],
        },
        // //金利の設定
        // SerectInt: "2.900",
        // kinri_syu: "変動金利型"
      }
    },
    methods: {
      clearAll() {
        // this.ruleForm.P1 = "",
        // this.ruleForm.P2 =  "",
        // this.ruleForm.P3 =  "",
        // this.ruleForm.P4 =  "",
        // this.ruleForm.P5 =  "",
        // this.ruleForm.S1 =  "",
        // this.ruleForm.S2 =  "",
        document.getElementById("P1").value = "",
          document.getElementById("P2").value = "",
          document.getElementById("P3").value = "",
          document.getElementById("P4").value = "",
          document.getElementById("P5").value = "",
          document.getElementById("S1").value = "",
          document.getElementById("S2").value = "",
          console.log("OK")
      },
      Main() {
        //変数の宣言と初期化
        var P1 = document.getElementById("P1").value; //お借り入れ金額
        var P2 = document.getElementById("P2").value; //ボーナスご返済希望金額
        var P3 = document.getElementById("P3").value; //ご返済希望年
        var P5 = document.getElementById("P5").value; //ご返済希望月
        var SerectInt = document.getElementById("P4").value; //金利
        var Result1; //Monthly repayment check
        var Result2; //Check for bonus repayment rate
        var Result3; //Check for all input items
        var Result4; // Check for all input items
        var Result5; //Check for all input fields
        var Result6; //Check for interest item
        var R1 = 0;
        var R2 = 0;
        var R3 = 0;

        if (P2 == '') {
          P2 = 0;
        }
        if (P1 == '') {
          alert(this.$t("JDSLoan.p1Alert") + "\n");
          return;
        }
        if ((P3 == '') && (P5 == '')) {
          alert(this.$t("JDSLoan.p2Alert") + "\n");
          return;
        }

        if ((P3 == '')) {
          P3 = 0;
        }
        if ((P5 == '')) {
          P5 = 0;
        }

        Result1 = correctstring(P1) * 10000;
        Result2 = correctstring(P2) * 10000;
        Result3 = correctstring(P3);
        Result5 = correctstring(P5);
        Result6 = correctstring2(SerectInt); // 金利の入力値チェック

        var period = eval(P3) * 12 + eval(P5);
        if ((Result1 == 0) && (Result2 == 0) && (Result3 == 0) && (Result5 == 0) && (Result6 == 0)) {
          Result4 = correctP1(P1 * 10000, P2 * 10000, period);
          if (Result4 == 0) {
            R1 = Math.round(Culc1(P1 * 10000, P2 * 10000, period, SerectInt)); //月々の返済額
            R3 = Math.round(Culc2(P2 * 10000, period, SerectInt)); //ボーナス返済額
            R2 = eval(R1) + eval(R3); //ボーナス月の返済額

            //フィールドへ渡すための項目定義
            document.getElementById("S1").value = String(eval(R1)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '4,'); //月々の返済額
            document.getElementById("S2").value = String(eval(R2)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g,
              '4,'); //ボーナス月の返済額
          }
        }
      },
      c_Pad(anynum, width) {
        return String(anynum).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      },
      Interest(P4) {
        SerectInt = P4.options[P4.selectedIndex].value;
        //金利種別
        if (P4.selectedIndex == 0) {
          kinri_syu = "変動金利型";
        }
        if (P4.selectedIndex == 1) {
          kinri_syu = "固定金利型";
        }
      },
      //入力チェック
      correctP1(n1, n2, n3) {
        var n = 0;
        //すべての値が上限を越えていないか？
        var err_masg = this.$t("JDSLoan.err_msg1") + "\n";
        var max_borrow = 10000000;
        var bornus_period = eval(n3 / 6);
        var max_bonus = Math.floor(eval(n1) / 2);
        var max_period = 120;
        var mini_period = 6;

        if ((n1 < 1) || (n1 > max_borrow)) {
          err_masg += this.$t("JDSLoan.err_msg2") + "\n"
          n = -1;
        }

        if ((n3 < mini_period) || (n3 > max_period)) {
          err_masg += this.$t("JDSLoan.err_msg3") + "\n"
          n = -1;
        }
        if ((n2 < 0) || (n2 > max_bonus)) {
          err_masg += this.$t("JDSLoan.wrong_bonus") + "\n"
          err_masg += this.$t("JDSLoan.over_bonus") + c_Pad(eval(max_bonus / 10000), 4) + this.$t(
            "JDSLoan.is_ten_thousand") + "\n"
          n = -1;
        }
        if (n == -1) {
          alert(err_masg);
        }

        return n;
      },

      correctstring(Str) {
        var Ret = 0;
        var n = Str.length;
        var err_masg = this.$t("JDSLoan.not_number") + "\n";
        var i = 0;

        //ニューメリックチェック
        if ((Str != 0)) {
          for (i = 0; i < n; i++) {
            if (("0" <= Str.charAt(i)) && (Str.charAt(i) <= "9")) {

            } else {
              alert(err_masg);
              Ret = -1;
              break;
            }
          }
        }

        return Ret;
      },

      // 金利の入力値チェック
      correctstring2(Str) {
        var Ret = 0;
        var n = Str.length;
        var err_masg = this.$t("JDSLoan.wrong_rate") + "\n";
        var i = 0;

        //ニューメリックチェック
        for (i = 0; i < n; i++) {
          if (("0" <= Str.charAt(i)) && (Str.charAt(i) <= "9")) {

          } else {
            if ("." != Str.charAt(i)) {
              alert(err_masg);
              Ret = -1;
              break;
            }
          }
        }
        if (Ret == 0) {
          if (eval(Str) == 0) {
            alert(err_masg);
            Ret = -1;
          }
        }
        return Ret;
      },

      Culc1(Money_Borrow, Money_Bonus, Times_R, interest_R) {
        //ローン返済式（毎月返済）
        var X1, X2, X3, X4, X5, X6;
        var interest = eval(interest_R) / 100 / 12
        var Times = eval(Times_R);
        var Money = (eval(Money_Borrow) - eval(Money_Bonus));

        //
        X1 = 1 + eval(interest);
        X2 = Math.pow(eval(X1), eval(Times));
        X3 = eval(Money) * eval(X2);

        //
        X4 = eval(X2) - 1;
        X5 = eval(X4) / eval(interest);

        //
        X6 = eval(X3) / eval(X5);

        return X6
      },

      //ボーナス返済額の計算
      //Money_Bonus
      //Times_R
      //interest_R
      //Money
      Culc2(Money_Bonus, Times_R, interest_R) {
        var X1, X2, X3, X4, X5, X6;
        var interest = eval(interest_R) / 100 / 2;
        var Times = eval(Times_R) / 6;

        //
        X1 = 1 + eval(interest);
        X2 = Math.pow(eval(X1), eval(Times));
        X3 = eval(Money_Bonus) * eval(X2);

        //
        X4 = eval(X2) - 1;
        X5 = eval(X4) / eval(interest);

        //
        X6 = eval(X3) / eval(X5);

        return X6;
      }
    }

  }

  // function c_Pad(anynum,width) {
  //     return String(anynum).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  // }

  //金利の設定
  //
  // var SerectInt="2.900";
  // var kinri_syu="変動金利型";

  // function Interest(P4){
  //     SerectInt = P4.options[P4.selectedIndex].value;

  //     //金利種別
  //   if (P4.selectedIndex == 0){
  //       kinri_syu = "変動金利型";
  //     }
  //     if (P4.selectedIndex == 1){
  //       kinri_syu = "固定金利型";
  //   }
  // }

  // function clearAll(){
  //     document.Shisan.P1.value = 0;
  //     document.Shisan.P2.value = 0;
  //     document.Shisan.P3.value = 0;
  //     document.Shisan.P5.value = 0;
  //     P1 = '';
  //     P2 = '';
  //     P3 = '';
  //     P5 = '';
  //     S1 = '';
  //     S3 = '';
  //     S2 = '';
  // }

  // function Main(Shisan){
  //     //変数の宣言と初期化
  //   var P1 = Shisan.P1.value;		//お借り入れ金額
  //   var P2 = Shisan.P2.value;		//ボーナスご返済希望金額
  //   var P3 = Shisan.P3.value;		//ご返済希望年
  //   var P5 = Shisan.P5.value;		//ご返済希望月
  //   var SerectInt = Shisan.P4.value;		//金利
  //   var Result1;               //Monthly repayment check
  //   var Result2;				//Check for bonus repayment rate
  //   var Result3;				//Check for all input items
  //   var Result4;				// Check for all input items
  //   var Result5;				//Check for all input fields
  //   var Result6;				//Check for interest item
  //   var R1 = 0;
  //   var R2 = 0;
  //   var R3 = 0;
  //     //
  //   if(P2==''){
  //     P2 = 0;
  //   }
  //   if (P1==''){
  //       alert("入力されていない項目があります！！\n");
  //     return;
  //   }
  //     if ((P3=='')&&(P5=='')){
  //       alert("ご返済期間を入力してください！！\n");
  //     return;
  //   }

  //   if ((P3=='')){
  //       P3 = 0;
  //   }
  //     if ((P5=='')){
  //       P5 = 0;
  //     }
  //     Result1 = correctstring(P1)*10000;
  //     Result2 = correctstring(P2)*10000;
  //     Result3 = correctstring(P3);
  //     Result5 = correctstring(P5);
  //   Result6 = correctstring2(SerectInt);	// 金利の入力値チェック

  //     var period = eval(P3)*12+ eval(P5);
  //     if ((Result1==0) && (Result2==0) && (Result3==0) && (Result5==0) && (Result6==0)){
  //     Result4 = correctP1(P1*10000,P2*10000,period);
  //     if (Result4 == 0){				//
  //       //
  //         R1 = Math.round(Culc1(P1*10000,P2*10000,period,SerectInt));			//月々の返済額
  //         R3 = Math.round(Culc2(P2*10000,period,SerectInt));			//ボーナス返済額
  //         R2 = eval(R1) + eval(R3);					//ボーナス月の返済額

  //       //
  //       //フィールドへ渡すための項目定義
  //         document.Send.S1.value = c_Pad(eval(R1),4);				//月々の返済額
  //         document.Send.S2.value = c_Pad(eval(R2),4);				//ボーナス月の返済額

  //       //
  //     }
  //   }
  // }

  //入力チェック
  function correctP1(n1, n2, n3) {
    var n = 0;
    //すべての値が上限を越えていないか？

    var err_masg = this.$t("JDSLoan.err_msg1") + "\n";
    var max_borrow = 10000000;
    var bornus_period = eval(n3 / 6);
    var max_bonus = Math.floor(eval(n1) / 2);
    var max_period = 120;
    var mini_period = 6;
    if ((n1 < 1) || (n1 > max_borrow)) {
      err_masg += this.$t("JDSLoan.err_msg2") + "\n"
      n = -1;
    }

    if ((n3 < mini_period) || (n3 > max_period)) {
      err_masg += this.$t("JDSLoan.err_msg3") + "\n"
      n = -1;
    }
    if ((n2 < 0) || (n2 > max_bonus)) {
      err_masg += this.$t("JDSLoan.wrong_bonus") + "\n"
      err_masg += this.$t("JDSLoan.over_bonus") + c_Pad(eval(max_bonus / 10000), 4) + this.$t(
        "JDSLoan.is_ten_thousand") + "\n"
      n = -1;
    }
    if (n == -1) {
      alert(err_masg);
    }

    return n;
  }


  //
  function correctstring(Str) {
    var Ret = 0;
    var n = Str.length;
    var err_masg = this.$t("JDSLoan.not_number") + "\n";
    var i = 0;

    //ニューメリックチェック
    if ((Str != 0)) {
      for (i = 0; i < n; i++) {
        if (("0" <= Str.charAt(i)) && (Str.charAt(i) <= "9")) {

        } else {
          alert(err_masg);
          Ret = -1;
          break;
        }
      }
    }

    return Ret;
  }

  // 金利の入力値チェック
  function correctstring2(Str) {
    var Ret = 0;
    var n = Str.length;
    var err_masg = this.$t("JDSLoan.wrong_rate") + "\n";
    var i = 0;

    //ニューメリックチェック
    for (i = 0; i < n; i++) {
      if (("0" <= Str.charAt(i)) && (Str.charAt(i) <= "9")) {

      } else {
        if ("." != Str.charAt(i)) {
          alert(err_masg);
          Ret = -1;
          break;
        }
      }
    }
    if (Ret == 0) {
      if (eval(Str) == 0) {
        alert(err_masg);
        Ret = -1;
      }
    }
    return Ret;
  }

  function Culc1(Money_Borrow, Money_Bonus, Times_R, interest_R) {
    //ローン返済式（毎月返済）
    var X1, X2, X3, X4, X5, X6;
    var interest = eval(interest_R) / 100 / 12
    var Times = eval(Times_R);
    var Money = (eval(Money_Borrow) - eval(Money_Bonus));

    //
    X1 = 1 + eval(interest);
    X2 = Math.pow(eval(X1), eval(Times));
    X3 = eval(Money) * eval(X2);

    //
    X4 = eval(X2) - 1;
    X5 = eval(X4) / eval(interest);

    //
    X6 = eval(X3) / eval(X5);

    return X6
  }

  //ボーナス返済額の計算
  //Money_Bonus
  //Times_R
  //interest_R
  //Money
  function Culc2(Money_Bonus, Times_R, interest_R) {
    var X1, X2, X3, X4, X5, X6;
    var interest = eval(interest_R) / 100 / 2;
    var Times = eval(Times_R) / 6;

    //
    X1 = 1 + eval(interest);
    X2 = Math.pow(eval(X1), eval(Times));
    X3 = eval(Money_Bonus) * eval(X2);

    //
    X4 = eval(X2) - 1;
    X5 = eval(X4) / eval(interest);

    //
    X6 = eval(X3) / eval(X5);

    return X6;
  }
</script>

<style scoped>
  .div {
    text-align: center;
  }

  .div-body {
    background-color: lightgoldenrodyellow;
  }

  .button {
    border: 2px solid lightskyblue;
    background-color: dodgerblue;
    border-radius: 8px;
    color: white;
    padding: 9px 20px;
    text-align: center;
    display: inline-block;
    font-size: 15px;
    margin: 2px 1px;
    cursor: pointer;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .input {
    background: #fafdfe;
    height: 26px;
    width: 176px;
    font-size: 14px;
    color: rgb(67, 90, 90);
    line-height: 26px;
    border: 1px solid #9bc0dd;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/components/JDSLoan.vue